export const trafficSources = {
    "Total Traffic": {
        priority: 0,
    },
    TotalTraffic: {
        priority: 0,
    },
    Direct: {
        priority: 1,
    },
    Mail: {
        priority: 2,
    },
    Email: {
        priority: 2,
    },
    Referrals: {
        priority: 3,
    },
    Social: {
        priority: 4,
    },
    OrganicSearch: {
        priority: 5,
    },
    "Organic Search": {
        priority: 5,
    },
    PaidSearch: {
        priority: 6,
    },
    "Paid Search": {
        priority: 6,
    },
    DisplayAds: {
        priority: 7,
    },
    "Display Ads": {
        priority: 7,
    },
    "Paid Referrals": {
        priority: 8,
    },
};
